import { render, staticRenderFns } from "./LivroCaixa.vue?vue&type=template&id=78a2e4b4&"
import script from "./LivroCaixa.vue?vue&type=script&lang=js&"
export * from "./LivroCaixa.vue?vue&type=script&lang=js&"
import style0 from "./LivroCaixa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports